const inputFile = () => {

    const parent    = '.js-input-file';
    const body      = '.js-input-file__body';
    const input     = '.js-input-file__file';
    const button    = '.js-input-file-button';
    const uploaded  = 'js-uploaded-file';

    $(document).on('click', button, function(){
        const inputFile  = $(this).parents(parent).find(input);

        inputFile.trigger('click');
    });

    $(input).on('change', function(){
        const thisParent = $(this).parents(parent);
        const thisBody   = thisParent.find(body);

        let uploadedFileName = this.files[0].name;

        if ( $(this).val ) {
            thisBody.hide();
            thisParent.append(uploadedFile(uploadedFileName, uploaded));
        }
    });

    $(document).on('click', '.js-uploaded-file', function(){
        const thisParent = $(this).parents(parent);
        const thisBody   = thisParent.find(body);
        const inputFile  = thisParent.find(input);

        thisBody.show();
        inputFile.val('');
        $(this).remove();
    });
}

const uploadedFile = (name, className) => {

    return '<button class="input-file__uploaded '+ className +'" type="button" title="Удалить файл">' +
        '<span class="input-file__uploaded-value js-uploaded-file-text">'+ name +'</span>' +
        '<span class="input-file__uploaded-icon">' +
            '<svg class="i">' +
                '<use xlink:href="#cross"></use>' +
            '</svg>' +
        '</span>' +
    '</button>';

}